// extracted by mini-css-extract-plugin
export default {"layout":"cad21fad6d _9a4e395e33 _05c5e1e7e4","h_slide":"_7558c6a4d9","category":"_3fb7e40a11 a815948fd7 e7f2bba64e"};